// https://brajeshwar.github.io/entities/

const INFINITY = "\u221e";
const ARROW_DOWN = "\u2193";
const ARROW_UP = "\u2191";

export default {
  INFINITY,
  ARROW_DOWN,
  ARROW_UP
};
